import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog'
import { ProductionListScope } from '../prod-list-scope'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { ProductionListConfSelectDirective } from '../production-list-conf-select.directive'
import { MatFormField } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton, MatButton } from '@angular/material/button'
import {
  ElderThemeDirective,
  ElderFormFieldDenseDirective,
  ElderSelectComponent,
  ElderSelectValueDirective,
  I18nPickAsyncPipe,
} from '@elderbyte/ngx-starter'
import { MatToolbar } from '@angular/material/toolbar'

export interface IProductionListConfSelectDialogOptions {
  readonly scopes: ProductionListScope[]
}

@Component({
  selector: 'app-production-list-conf-select-dialog',
  templateUrl: './production-list-conf-select-dialog.component.html',
  styleUrls: ['./production-list-conf-select-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatFormField,
    ElderFormFieldDenseDirective,
    ElderSelectComponent,
    ProductionListConfSelectDirective,
    ElderSelectValueDirective,
    MatButton,
    AsyncPipe,
    ElderTranslatePipe,
    I18nPickAsyncPipe,
  ],
})
export class ProductionListConfSelectDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public selection: string
  public readonly scopes: ProductionListScope[]
  dialogRef = inject<MatDialogRef<ProductionListConfSelectDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IProductionListConfSelectDialogOptions>(MAT_DIALOG_DATA)
    this.scopes = data.scopes
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onConfirm($event: Event): void {
    this.close(this.selection)
  }

  public close(selection?: string): void {
    this.dialogRef.close(selection)
  }
}
